var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import authentication from "@irati/auth";
import { hangPromise } from "@irati/utils/promise";
import Loading from "@irati/ui/src/Loading";
import { Body, H3 } from "@irati/ui/src/Typography";
import { FormattedMessage, injectIntl, LangLoader } from "@irati/utils/lang";
import perksGOCardIcon from "@irati-web/perksgo/src/images/perksGO_cardIcon.svg";
import { PERKSGO } from "@irati-web/app/src/routeConfig";
import perksGOTracking from "@irati-tracking/perksgo/perksGO";
import ModalLocation from "@irati-tracking/perksgo/enums/ModalLocation";
import linkedCardService from "@irati/perksgo/services/linkedcards";
import { Band, BannerWrapper, PerksGOImage, StyledSpan, TitleWrapper, StyledButton, StyledClose, TextImageWrapper, ButtonWrapper } from "./styled/PerksGOBanner";
import FindOutMore from "../Popup/FindOutMore";
var PerksGOBanner = /** @class */ (function (_super) {
    __extends(PerksGOBanner, _super);
    function PerksGOBanner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            load: hangPromise(),
            shouldShowPerksGoBanner: undefined
        };
        _this.findOutMorePopup = React.createRef();
        _this.componentDidMount = function () {
            _this.setState({ load: _this.shouldShowPerksGoBanner() });
        };
        _this.shouldShowPerksGoBanner = function () {
            return linkedCardService.shouldShowPerksGoBanner(authentication.user()).then(function (shouldShowPerksGoBanner) {
                _this.setState({ shouldShowPerksGoBanner: shouldShowPerksGoBanner });
            });
        };
        _this.showModal = function () {
            perksGOTracking.showFindOutMoreModal(ModalLocation.Homepage);
            _this.findOutMorePopup.current.show();
        };
        _this.closeBanner = function () {
            linkedCardService.hasDismissedLinkedCardBanner(authentication.user());
            _this.setState({ shouldShowPerksGoBanner: false });
        };
        return _this;
    }
    PerksGOBanner.prototype.render = function () {
        var _a = this.props, isPhone = _a.isPhone, formatMessage = _a.formatMessage;
        var _b = this.state, load = _b.load, shouldShowPerksGoBanner = _b.shouldShowPerksGoBanner;
        if (!shouldShowPerksGoBanner) {
            return null;
        }
        return (React.createElement(Loading, { load: load, useLoader: false },
            React.createElement(React.Fragment, null,
                !isPhone && React.createElement(Band, null),
                React.createElement(LangLoader, { bucket: PERKSGO },
                    React.createElement(BannerWrapper, null,
                        React.createElement(TextImageWrapper, null,
                            React.createElement(PerksGOImage, { src: perksGOCardIcon, alt: formatMessage({ id: "perksgo.banner.imageAlt" }) }),
                            React.createElement("section", null,
                                React.createElement(TitleWrapper, null,
                                    React.createElement(H3, null,
                                        React.createElement(FormattedMessage, { id: "perksgo.banner.title", values: {
                                                name: (React.createElement(StyledSpan, null,
                                                    React.createElement(FormattedMessage, { id: "perksgo.banner.name" })))
                                            } }))),
                                React.createElement(Body, { small: true, marginTop: 1 },
                                    React.createElement(FormattedMessage, { id: "perksgo.banner.text" })))),
                        React.createElement(ButtonWrapper, null,
                            React.createElement(StyledButton, { full: true, primary: true, onClick: this.showModal },
                                React.createElement(FormattedMessage, { id: "perksgo.banner.button" }))),
                        React.createElement(StyledClose, { inline: false, onClick: this.closeBanner })))),
            React.createElement(FindOutMore, { ref: this.findOutMorePopup, modalLocation: ModalLocation.Homepage })));
    };
    return PerksGOBanner;
}(PureComponent));
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return ({
        isPhone: get(mq, "lessThan.medium", false)
    });
};
export default injectIntl(connect(mapStateToProps, null)(PerksGOBanner));
